export const classes = {
  title: 'text-grey-8 font-semibold text-2xl mb-3',
};
